var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3075 1.60559C13.2476 1.55893 13.1779 1.52651 13.1036 1.51081C13.0293 1.49511 12.9524 1.49653 12.8788 1.51497L4.87875 3.51497C4.77058 3.54201 4.67455 3.60443 4.60593 3.6923C4.5373 3.78018 4.50002 3.88847 4.5 3.99997V10.88C4.0829 10.6013 3.58462 10.47 3.08434 10.5069C2.58407 10.5438 2.11048 10.7469 1.73882 11.0838C1.36716 11.4207 1.11876 11.8722 1.03307 12.3665C0.947383 12.8607 1.02933 13.3695 1.26589 13.8118C1.50244 14.2542 1.88004 14.6048 2.3387 14.808C2.79735 15.0112 3.31075 15.0552 3.79732 14.9332C4.28389 14.8112 4.71573 14.5301 5.02423 14.1345C5.33273 13.7389 5.50019 13.2516 5.5 12.75V4.39059L12.5 2.64059V8.87997C12.0829 8.60128 11.5846 8.46997 11.0843 8.5069C10.5841 8.54384 10.1105 8.7469 9.73882 9.08382C9.36716 9.42074 9.11876 9.8722 9.03307 10.3665C8.94738 10.8607 9.02933 11.3695 9.26589 11.8118C9.50244 12.2542 9.88004 12.6048 10.3387 12.808C10.7974 13.0112 11.3107 13.0552 11.7973 12.9332C12.2839 12.8112 12.7157 12.5301 13.0242 12.1345C13.3327 11.7389 13.5002 11.2516 13.5 10.75V1.99997C13.5 1.92392 13.4827 1.84887 13.4493 1.78053C13.416 1.71219 13.3675 1.65236 13.3075 1.60559Z",
    fill: "#7C63A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusical);
export default __webpack_public_path__ + "static/media/musical.41f2fde0e9952c816008f4d935881fbd.svg";
export { ForwardRef as ReactComponent };